var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.4,
    fillRule: "evenodd",
    d: "M7.114 7.917a.5.5 0 0 0-.353.853l3.549 3.549a.5.5 0 0 0 .707 0l3.549-3.549a.5.5 0 0 0-.354-.853z",
    clipRule: "evenodd"
  })));
};
export default SvgArrow;